<template>
  <div class="d-flex justify-content-center align-items-center min-vh-100">
    <div class="text-center">
      <div class="spinner-border text-primary mb-3" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <h3>Connecting to ADP...</h3>
      <p class="text-muted">Please wait while we redirect you to ADP for authentication.</p>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import ApiClient from '@/ApiClient';

onMounted(async () => {
  try {
    const url = new URL(window.location.href);
    const iss = url.searchParams.get('iss');

    const response = await ApiClient.postADPSSOStart({
      iss: iss,
      redirect_uri: `${window.location.origin}/adp-login-callback`,
    });

    if (response?.data?.authorization_uri) {
      window.location.href = response.data.authorization_uri;
    } else {
      console.error('No authorization URL received from backend');
    }
  } catch (error) {
    console.error('Failed to start ADP SSO flow:', error);
  }
});
</script>
